export default __webpack_public_path__ + "img/icon01.6cd339c1.svg";